import React from 'react'
import styled from 'styled-components'
import { Container, opacityBackgroundCss } from '@rst/ui-ts'

import BG_IMG from '../assets/bg.jpg'
import { Animations } from '../../../../types'
import { BlockAnimation } from '../../../common/animations'
import { useThemeContext } from '../../../../lib/theme.ctx'
import { withUrl } from '@rst/libs-ts'

const LeadFormWrapper: React.FC<{
	parallax?: boolean
	children?: React.ReactNode
	animation?: Animations.AnimationParams
	blockId?: string
}> = ({ children, parallax, animation, blockId }) => {
	const { lead } = useThemeContext()

	return (
		<Wrapper
			bgImage={withUrl(lead?.bg_image || BG_IMG)}
			bgColor={lead?.bg_color || 'primary'}
			parallax={parallax}
		>
			<BlockAnimation
				animation={animation}
				bgImage={withUrl(lead?.bg_image || BG_IMG)}
				bgColor={lead?.bg_color || 'primary'}
				blockId={blockId}
			>
				<Container>{children}</Container>
			</BlockAnimation>
		</Wrapper>
	)
}

export { LeadFormWrapper }
export default LeadFormWrapper

const Wrapper = styled.div<{
	bgImage: string
	bgColor: string
	parallax?: boolean
}>`
	width: 100%;
	background-attachment: ${({ parallax }) => (parallax ? 'fixed' : 'unset')};
	${opacityBackgroundCss}
`
